import React from 'react';
import { connect } from 'react-redux';
import './style.scss';
import MaximizedFrame from '../../base/maximized';
import MinimizedFrame from '../../base/minimized';
import * as WidgetActions from '../../layers/widget/actions';
import { VIEW_MODES } from '../../views/types';
import { setCallView, setCallRegistration } from './actions';
import Tracker from '../../../genesys/tracker';
import F_1 from './wizard/f_1';
import F_2 from './wizard/f_2';
import F_3 from './wizard/f_3';
import F_4 from './wizard/f_4';
import F_5 from './wizard/f_5';
import Q_1 from './wizard/q_1';
import Q_2 from './wizard/q_2';

const LoginMode = {
    Quick: 'quick',
    Full: 'full',
    Offer: 'offer'
};

class Click2Call extends React.Component {
    constructor(props) {
        super(props);

        // const uri = new Uri(props.location);
        // const args = uri.searchObject;
        const args = { ...props.settings.startArguments };

        const { dispatch } = this.props;
        if (this.props.call.view === '') {
            args['userIdentificationNumber'] =
                args['userIdentificationNumber'] ||
                args['msisdn'] ||
                args['product_number'];
            // args['categoryLine'] = args['client_type'] || null;
            // args['categorySegment'] = args['customer_type'] || null;

            let nextView;
            switch (args['login_type']) {
                case LoginMode.Full:
                    nextView = 'F_1';
                    break;
                case LoginMode.Quick:
                    nextView = 'Q_1';
                    break;
                case LoginMode.Offer:
                    nextView = 'F_4';
                    break;
                default:
                    break;
            }
            this.args = args;
            dispatch(setCallRegistration(args));
            dispatch(setCallView(nextView));
        }

        this.nextStep = this.nextStep.bind(this);
        this.saveValues = this.saveValues.bind(this);
    }

    componentDidMount() {
        if (!this.props.config) {
            // Tracker.sendEvent('widgetTest1', this.args);
            Tracker.sendEvent('mobileCallGet', this.args); // required: userIdentificationNumber, iccid, login_type
        }
    }

    formatHtml(message) {
        return message.replace(/(&nbsp;)/gi, ' '); // in ' ' is non-breaking-space (U+00A0) which will be replaced by real &nbsp; by react.
    }

    nextStep(step, reason = undefined) {
        const { dispatch } = this.props;
        if (step === null) {
            WidgetActions.onClose('click2call', false, reason);
        }
        dispatch(setCallView(step));
    }

    saveValues(state) {
        const { dispatch } = this.props;
        dispatch(setCallRegistration(state));
    }

    render() {
        const {
            widget,
            call,
            // config,
            minimize,
            maximize,
            close
        } = this.props;

        let content;
        if (this.props.config || call.registration.reinvite) {
            content = (
                <div className="click2call--container">
                    {call.view === 'F_1' && (
                        <F_1
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                    {call.view === 'F_2' && (
                        <F_2
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                    {call.view === 'F_3' && (
                        <F_3
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                    {call.view === 'F_4' && (
                        <F_4
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                    {call.view === 'F_5' && (
                        <F_5
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                    {call.view === 'Q_1' && (
                        <Q_1
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                    {call.view === 'Q_2' && (
                        <Q_2
                            nextStep={this.nextStep}
                            saveValues={this.saveValues}
                        />
                    )}
                </div>
            );
        } else {
            content = (
                <div className="click2call--container">
                    <div className="click2call--groups">
                        <div className="click2call--group click2call--group-label">
                            <p>Pobieram dane…</p>
                        </div>
                        <div className="click2call--group" />
                    </div>
                </div>
            );
        }

        switch (widget.currentMode) {
            case VIEW_MODES.MINIMIZED:
                return (
                    <MinimizedFrame
                        type="bar"
                        title="Zadzwoń"
                        events={{ maximize }}
                    />
                );
            case VIEW_MODES.MAXIMIZED:
                return (
                    <MaximizedFrame
                        type="large"
                        title="Zadzwoń"
                        background="gray"
                        events={{ minimize, close }}
                    >
                        {content}
                    </MaximizedFrame>
                );
            default:
                return null;
        }
    }
}

const mapStateToProps = state => {
    return {
        widget: state.widget,
        call: state.call,
        settings: state.settings,
        location: state.main.location,
        config: state.config.widget ? state.config.widget.callOptions : null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch,
        minimize: () => dispatch(WidgetActions.onMinimize()),
        maximize: () => dispatch(WidgetActions.onMaximize()),
        close: () => WidgetActions.onClose('click2call')
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Click2Call);
